module.exports = __webpack_public_path__ + "img/girl.1d107593.png";